import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkFlowReportService } from '../../../../../services/workflowreport.service';
import { DialogImageComponent } from '../../../dialog-image/dialog-image.component';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'wdm-supervisor-report',
  templateUrl: 'supervisor-report.component.html',
  styleUrls: ['supervisor-report.component.scss']
})

export class SuperVisorReportComponent implements OnInit{

  @Input() stepinfo: any;
  data: SupervisorReportData | null = null;
  predictionMinScore: number = environment.predictionMinimumScore;

  constructor(public workFlowReportService: WorkFlowReportService, public dialog: MatDialog) {
    console.log(this.stepinfo);
  }

  ngOnInit() {
    this.data = JSON.parse(this.stepinfo.result);
  }

  getValidPredictions(): SupervisorPrediction[] {
    return this.data?.Predictions?.filter(prediction => prediction.ProbabilityValue >= this.predictionMinScore) ?? [];
  }

  openImage(imageURL: string) {
    const dialogImage = this.dialog.open(DialogImageComponent, {
      width: '90%',
      data: {
        img: imageURL,
      }
    });
  }

}


export interface SupervisorReportData {
  PredictedFileName: string;
  Predictions: SupervisorPrediction[];
}

export interface SupervisorPrediction {
  Label: string;
  ProbabilityString: string;
  ProbabilityValue: number;
}
